export default __webpack_public_path__ + "static/media/newApiToken.73c53257.png";